'use client';

import Link from '@eliadmin/core/src/components/link';

import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../ui/heading';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Button } from '../ui/button';
import { ROUTES } from '../../constants/routes';
import { GoArrowLeft } from 'react-icons/go';
import { FiPhoneCall } from 'react-icons/fi';
import { Logo } from '../ui/logo';

export function CartHeader({ generalLayout }: { generalLayout: GeneralLayout['data'] }) {
  const { t } = useTranslations();

  return (
    <div className={cn('custom-section', 'border-b border-b-border py-4 sm:py-6 lg:py-8')}>
      <div
        className={cn('custom-container--xxl', 'hidden items-center justify-between gap-4 sm:flex')}
      >
        <div className="flex flex-1 items-center justify-start">
          <Button asChild variant={'outline'}>
            <Link prefetch={false} href={ROUTES.HOME()}>
              <GoArrowLeft size={24} /> {t('text208')}
            </Link>
          </Button>
        </div>
        <Heading title={t('text163')} />
        <div className="flex flex-1 items-center justify-end">
          <Button asChild variant={'outline'}>
            <Link prefetch={false} href={`tel:${generalLayout?.contact?.phone}`} target="_blank">
              <FiPhoneCall size={24} /> {generalLayout?.contact?.phone}
            </Link>
          </Button>
        </div>
      </div>
      <div className="flex w-full items-center justify-between gap-4 sm:hidden">
        <Button asChild variant={'outline'} size={'icon'}>
          <Link prefetch={false} href={ROUTES.HOME()}>
            <GoArrowLeft size={20} />
          </Link>
        </Button>
        <Logo generalLayout={generalLayout} className={{ image: 'h-8' }} />
        <Button asChild size={'icon'} variant={'outline'}>
          <Link prefetch={false} href={`tel:${generalLayout?.contact?.phone}`} target="_blank">
            <FiPhoneCall size={20} />
          </Link>
        </Button>
      </div>
    </div>
  );
}
